//Updated reports header
import React from 'react';
import styles from '../css/activitiesRptUpdated.module.css';
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function UpdatedReportsHero({ reportData, exportPulse, sortKey, sorted, columns, handleExport }) {
  const navigate = useNavigate();
  return (
    <div className={styles.headerDiv}>
      <div className={styles.sortedLabelDiv}>
        <div className={styles.sortedSvgDiv}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M3 9h18M3 15h18M9 3v18" />
          </svg>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 25,
          }}
        >
          <a
            href="##"
            onClick={() => navigate('/')}
            className={styles.headerTitle}
            style={{ margin: 0, fontSize: 14, fontWeight: 500, color: 'blue' }}
          >
            <FaHome size={17} style={{ paddingTop: '6px' }} /> Home
          </a>
          <p className={styles.headerSub} style={{ margin: 0, fontSize: 12, color: '#6b7280' }}>
            {sorted.length} records · sorted by {columns.find((c) => c.key === sortKey)?.label}
          </p>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div
          style={{
            fontSize: 12,
            color: '#6366f1',
            background: '#eef2ff',
            padding: '4px 10px',
            borderRadius: 20,
            fontWeight: 500,
          }}
        >
          {reportData.length} records
        </div>
        <button className={`${styles.exportBtn}${exportPulse ? '.' + styles.pulse : ''}`} onClick={handleExport}>
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Export CSV
        </button>
      </div>
    </div>
  );
}

export default UpdatedReportsHero;
